import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { LoadingController } from '@ionic/angular';
interface Booking {
  key: string;
  phone: string ;
  date: string ;
  contact: string ;
  ser: string ;
  datesub: string ;
}

@Injectable({
  providedIn: 'root'
})

export class AppserviceService {
  id = 0;
  cartype = '';
  serviceid: number = null;
  serviceselected = '';
  connected = false ;
  bookings: Booking[] = [];
  constructor(
    private afs: AngularFirestore,
    private lc: LoadingController
  ) {

  }

  loadBookings() {
    this.lc
    .create({
      message: 'جاري تحميل الطلبات ... ',
      spinner: 'dots',
    }).then((l) => {
      l.present();
      this.afs.collection<Booking>('_bookingApp').valueChanges().subscribe( res => {
        this.bookings = [];
        this.bookings = res;
        l.dismiss();
      });

    });

  }

  async move(bok: Booking) {
    await this.afs.collection('_bookingApp').doc(`${bok.key}`).delete();
    await this.afs.collection('_movedbooking').doc(`${bok.key}`).set(bok);

  }

  async delete(bok: Booking) {
    await this.afs.collection('_bookingApp').doc(`${bok.key}`).delete();
    await this.afs.collection('_deletedBooking').doc(`${bok.key}`).set(bok);

  }


  async update() {
    await this.afs.collection<Booking>('_bookingApp').get().subscribe( r=> {
      r.forEach(async (d) => {
        const newdata: Booking = d.data() ;
        newdata.key = d.id ;
        newdata.datesub='';
        await this.afs.collection('_bookingApp').doc(`${newdata.key}`).update(newdata);
      });
    });
  }

  getandmove() {
    this.bookings.forEach(async (book) => {
      if(book.datesub.length >1) {
        console.log(book);
      } else {
        await this.afs.collection('_deletedBooking').doc(`${book.key}`).set(book);
        await this.afs.collection('_bookingApp').doc(`${book.key}`).delete();

      }
    });
  }
}
